export default __webpack_public_path__ + "static/ultherapy_2-902342c503c8407c8af73b8e5dc3499b.jpg";